
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Solucao from './components/Solucao';
import Conteudo from './components/Conteudo';
import ParaQuem from './components/ParaQuem';
import ProvaSocial from './components/ProvaSocial';
import Garantia from './components/Garantia';
import Oferta from './components/Oferta';
import CTAFinal from './components/CTAFinal';
import Navbar from './components/Navbar';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />
      <Hero />
      <Solucao />
      <Conteudo />
      <ParaQuem />
      <ProvaSocial />
      <Garantia />
      <Oferta />
      <CTAFinal />
    </div>
  );
}
